import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MdbTabsComponent } from 'mdb-angular-ui-kit/tabs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { TokenStorageService } from '../../services/storage/token-storage.service';
import { SessionService } from '../../services/session/session.service';
import { UserService } from '../../services/user.service';

import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { AccountViewComponent } from './account-view.component';


@Component({
    selector: 'app-customer-creation',
    templateUrl: './customer-creation.component.html',
    styleUrls: ['./customer-creation.component.css'],
    standalone: false
})
export class CustomerCreationComponent implements OnInit {
  @Output() btnClicked = new EventEmitter<void>();
  isProfileCreation: boolean = true;
  isSubscribPack: boolean = false;
  isDefaultProfileSet: boolean = false;
  selectedValue: any = '0';
  loading: boolean = false;
  blureBackGround = false;
  isDefaultPackageSet: boolean = false;
  customerCreateModalRef: MdbModalRef<CustomerCreationModalComponent> | null =
    null;
  subscribePackCreateModalRef: MdbModalRef<SubscriptionPackCreationModalComponent> | null =
    null;
  accountViewModalRef: MdbModalRef<AccountViewComponent> | null = null;
  exchange: any;
  exchnageFormEdited: boolean = false;
  institutions: any;
  createCustomerSubmitted: boolean = false;
  customerCreationForm: FormGroup = new FormGroup({});
  profileList: any = [];
  selectionForm: FormGroup = new FormGroup({});

  isSuccessful: boolean = false;
  errorMessage: string = '';
  initialLoading: boolean = false;
  isLoggedIn: boolean = false;
  role: string = '';
  user: any;
  items: any;
  env:any;

  selectedOption: any;
  subscriptionPlanList: any = [];
  static exchanges: any;
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private tokenStorage: TokenStorageService,
    private userService: UserService,
    private router: Router, //public modalRef: MdbModalRef<RegistrationPageComponent>
    private sessionStorageService: SessionService,
    private modalService: MdbModalService
  ) { }

  ngOnInit(): void {

    this.initializeSelectionForm();

    this.items = [
      { id: 0, name: 'Customer Profile Creation' },
      { id: 1, name: 'Subscription Package Creation' },
    ];
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.user = this.tokenStorage.getUser().username;
      this.role = this.user.role;
      this.env = this.tokenStorage.getUserEnv();
    }
  }
  getInstSubscriptionPackageList() {
    const instCode = this.sessionStorageService.getItem('newInstCode');
    if (instCode) {
      this.loading = true;
      this.userService.getInstSubscriptionPackageList(instCode, this.env).subscribe({
        next: (data: any) => {
          if (data.status == 'SUCCESS') {
            this.subscriptionPlanList = data?.packageList.sort(
              (a: any, b: any) => (a.packageName > b.packageName ? 1 : -1)
            );
            this.loading = false;

          } else {
            this.loading = false;
          }
        },
        error: (err) => {
          this.loading = false;
        },
      });
    }
  }
  defaultSubscribePack(id: any) {
    const instCode = this.sessionStorageService.getItem('newInstCode');
    this.loading = true;
    this.blureBackGround = true;
    this.userService.defaultSubscriptionPackage(id, instCode).subscribe(
      (data: any) => {
        this.getInstSubscriptionPackageList();
        this.loading = false;
        this.blureBackGround = false;
      },
      (err: any) => {
        this.toastr.error('Error Occured');
        this.loading = false;
        this.blureBackGround = false;
      }
    );
  }
  handleProfileCreate() {
    this.customerCreateModalRef = this.modalService.open(
      CustomerCreationModalComponent,
      {
        modalClass: 'modal-lg modal-dialog-centered',
      }
    );
    this.customerCreateModalRef.onClose.subscribe((message: any) => {
      this.getCustomerProfileList();
    });
  }

  handleAccountDetailsView(customerNo:any) {


    this.accountViewModalRef = this.modalService.open(AccountViewComponent, {
      modalClass: 'modal-lg modal-dialog-centered',
      data:{customerNo:customerNo}
    });
  }
  handleSubscribePack() {
    this.subscribePackCreateModalRef = this.modalService.open(
      SubscriptionPackCreationModalComponent,
      {
        modalClass: 'modal-lg modal-dialog-centered',
      }
    );
    this.subscribePackCreateModalRef.onClose.subscribe((message: any) => {
      this.getInstSubscriptionPackageList();
    });
  }
  defaultProfile(id: any) {
    this.loading = true;
    this.blureBackGround = true;
    const instCode = this.sessionStorageService.getItem('newInstCode');
    this.userService.defaultProfile(id, instCode).subscribe(
      (data: any) => {
        this.toastr.success('Default Profile Created');

        this.getCustomerProfileList();
        this.loading = false;
        this.blureBackGround = false;
      },
      (err: any) => {
        this.toastr.error('Error Occured');
        this.loading = false;
        this.blureBackGround = false;
      }
    );
  }
  selectChange() {
    if (this.selectedValue == '0') {
      this.isProfileCreation = true;
      this.isSubscribPack = false;
    }
    if (this.selectedValue == '1') {
      this.isSubscribPack = true;
      this.isProfileCreation = false;
    }
  }

  subscribePackEdit(id: any) {
    this.sessionStorageService.removeItem('packageId');
    this.sessionStorageService.setItem('packageId', id);
    this.getInstSubscriptionPackageList();
    setTimeout(() => {
      this.subscribePackCreateModalRef = this.modalService.open(
        SubscriptionPackCreationModalComponent,
        {
          modalClass: 'modal-lg modal-dialog-centered',
          data: {
            packageData: this.subscriptionPlanList.filter(
              (item: any) => item.packageId == id
            )[0],
            isEditPackage: true,
            exchangeList: this.subscriptionPlanList.filter(
              (item: any) => item.packageId == id
            )[0].exchangeList,
            exchangeVisible: true,
          },
        }
      );

      this.subscribePackCreateModalRef.onClose.subscribe((message: any) => {
        this.getInstSubscriptionPackageList();
      });
    }, 100);


  }

  getCustomerProfileList(): void {
    const instCode = this.sessionStorageService.getItem('newInstCode');
    this.loading = true;
    this.userService.getInstCustomerProfile(instCode, 'asia').subscribe({
      next: (data: any) => {
        if (data.status == 'SUCCESS') {
          this.profileList = data?.profileList.sort((a: any, b: any) =>
            a.profileName > b.profileName ? 1 : -1
          );

          this.loading = false;
        } else {
          this.loading = false;
        }
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  initializeSelectionForm(): void {
    this.selectionForm = this.formBuilder.group({
      type: ['', [Validators.required]],
    });
  }

  reloadPage(): void {
    window.location.reload();
  }

  goNext(): void {
    this.profileList.forEach((element: any) => {
      if (element.isDefault == 'YES') {
        this.isDefaultProfileSet = true;
      }
    });
    this.subscriptionPlanList.forEach((element: any) => {
      if (element.isDefault == 'YES') {
        this.isDefaultPackageSet = true;
      }
    });


    if (this.isSubscribPack) {
      if (this.isDefaultPackageSet) {
        this.btnClicked.emit();
      } else {
        this.toastr.error('Please Set Default Package');
      }
    }
    if (this.isProfileCreation) {
      if (this.isDefaultProfileSet) {
        this.btnClicked.emit();
      } else {
        this.toastr.error('Please Set Default Profile');
      }
    }
  }
}

@Component({
    selector: 'profile-creation-modal',
    templateUrl: 'profile-creation-modal.html',
    styleUrls: ['./customer-creation.component.css'],
    standalone: false
})
export class CustomerCreationModalComponent {
  isProfileCreation: boolean = true;
  createCustomerSubmitted: boolean = false;
  customerCreationForm: FormGroup = new FormGroup({});
  selectedValue: any = '0';
  loading: boolean = false;
  customerAccountNumber: any;
  profileCreated: boolean = false;
  errorMessage: any;
  initialLoading: boolean = false;
  cashAccForm: FormGroup = new FormGroup({});
  cashAccountList: any=[];
  currencyList: any=[];
  exchangeAccountList: any=[];
  securityAccountList: any=[];
  exchanges: any=[];
  createAccClicked: boolean = false;
  createCashAccountClicked: boolean = false;
  createSecurityAccountClicked: boolean = false;
  createExchangeAccClicked: boolean = false;
  securityAccLocked: boolean = false;
  exchangeAccLocked: boolean = false;
  loadingAcc: boolean = false;
  env:any;
  constructor(
    public modalRef: MdbModalRef<CustomerCreationModalComponent>,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastr: ToastrService,
    private sessionStorageService: SessionService,
    private CustomerCreationComponent: CustomerCreationComponent,
    private tokenStorage: TokenStorageService
  ) {}

  ngOnInit(): void {
    this.initializecustomerCreationForm();
    this.initializeCashAccForm()
    this.getCurrencyList()
    this.getInstExchangeList()
    this.env = this.tokenStorage.getUserEnv();

  }

  onClickCreateProfile() {
    const instCode = this.sessionStorageService.getItem('newInstCode');
    this.createCustomerSubmitted = true;
    if (this.customerCreationForm.invalid) {
      this.toastr.error('Please fill the form', 'Error');
      return;
    }

    const { profileName, description, defaultProfile } =
      this.customerCreationForm.value;
    this.loading = true;
    this.userService
      .customerProfileCreation(profileName, description, instCode, 1, 'NO')
      .subscribe({
        next: (data: any) => {
          if (data.status == 'SUCCESS') {
            this.CustomerCreationComponent.getCustomerProfileList();
            this.loading = false;
            this.customerCreationForm.get('profileName')?.disable();
            this.customerCreationForm.get('description')?.disable();


            this.customerAccountNumber = data.profileList[0].profileNumber;
            this.profileCreated = true;

            this.toastr.success('User profile added successfully', 'Success');
          } else {
            this.CustomerCreationComponent.getCustomerProfileList();
            this.loading = false;
            this.toastr.error(data.reason, 'User profile added failed');
          }
        },
        error: (err) => {
          this.loading = false;
          this.toastr.error(err.error.message, 'User profile added  failed');
        },
      });
  }

  initializecustomerCreationForm(): void {
    this.customerCreationForm = this.formBuilder.group({
      profileName: ['', [Validators.required]],
      description: ['', [Validators.required]],
      defaultProfile: [''],
    });
  }

  get formProfileCreationControl(): { [key: string]: AbstractControl } {
    return this.customerCreationForm.controls;
  }
  closeModal(): void {
    this.modalRef.close();
  }




  getCurrencyList() {
    this.initialLoading = true;
    this.userService.getCurrencyList().subscribe({
      next: (data) => {
        if (data.status == 'SUCCESS') {
          this.currencyList = data.list.sort((a: any, b: any) =>
            a.type > b.type ? 1 : -1
          );
        } else {
          this.errorMessage = data.reason;
          this.toastr.error(
            this.errorMessage,
            'Error getting currency list'
          );
        }
        this.initialLoading = false;
      },
      error: (err) => {
        this.errorMessage = err.error.message;
        this.toastr.error(
          this.errorMessage,
          'Error getting currency list'
        );
        this.initialLoading = false;
      },
    });
  }

  initializeCashAccForm(): void {
    this.cashAccForm = this.formBuilder.group({
      masterAccCashAccCurrency: ['', [Validators.required]],
      masterAccCashAccId: ['', [Validators.required]],
      masterAccSecurityAccType: ['', [Validators.required]],
      masterAccSecurityAccId: ['', [Validators.required]],
      masterAccExchangeAccExchange: ['', [Validators.required]]
    });
  }
  createSecurityAccount(){
    this.createSecurityAccountClicked = true;
    this.loadingAcc = true;
    if (this.cashAccForm.invalid && this.formBankControl['masterAccSecurityAccType'].errors) {
      this.loading = false
      return;
    }

    const {
      masterAccSecurityAccType,
      masterAccCashAccId
    } = this.cashAccForm.value

    this.userService.createSecurityAccount(masterAccCashAccId, masterAccSecurityAccType)
      .subscribe({
        next: (data) => {
          if (data.status == 'SUCCESS') {
            this.toastr.success(data.reason, 'Success');
            this.exchangeAccLocked = true
            this.securityAccountList.push({accountNumber: data.accountNumber, accountType: masterAccSecurityAccType,cashAccId: masterAccCashAccId})
            // TODO : Create a list & add newly created cash accounts to that
          } else {

            this.errorMessage = data.reason;
            this.toastr.error(
              this.errorMessage,
              'Unable to create security account'
            );
          }
          this.loadingAcc = false;
        },
        error: (err) => {
          this.errorMessage = err.error.message;
          this.toastr.error(
            this.errorMessage,
            'Unable to create security account'
          );
          this.loadingAcc = false;
        },
      });
  }
  createCashAccount() {
    this.createCashAccountClicked = true;
    this.loadingAcc = true;
    if (this.cashAccForm.invalid && this.formBankControl['masterAccCashAccCurrency'].errors) {
      this.loadingAcc = false
      return;
    }

    const {
      masterAccCashAccCurrency
    } = this.cashAccForm.value

    this.userService.createCashAccount(this.customerAccountNumber, masterAccCashAccCurrency)
      .subscribe({
        next: (data) => {
          if (data.status == 'SUCCESS') {
            this.toastr.success(data.reason, 'Success');
            this.securityAccLocked = true
            this.cashAccountList.push({currency: masterAccCashAccCurrency, accountNumber: data?.cashAccountNumber})

            // TODO : Create a list & add newly created cash accounts to that
          } else {
            this.errorMessage = data.reason;
            this.toastr.error(
              this.errorMessage,
              'Unable to create cash account'
            );
          }
          this.loadingAcc = false;
        },
        error: (err) => {
          this.errorMessage = err.error.message;
          this.toastr.error(
            this.errorMessage,
            'Unable to create cash account'
          );
          this.loadingAcc = false;
        },
      });
  }
  createExchangeAccount(){
    this.createExchangeAccClicked = true;
    this.loadingAcc = true;
    if (this.cashAccForm.invalid && this.formBankControl['masterAccExchangeAccExchange'].errors) {
      this.loadingAcc = false
      return;
    }

    const {
      masterAccExchangeAccExchange,
      masterAccSecurityAccId
    } = this.cashAccForm.value


    this.userService.createExchangeAccount(masterAccSecurityAccId, masterAccExchangeAccExchange ,'', '')
      .subscribe({
        next: (data) => {
          if (data.status == 'SUCCESS') {
            this.toastr.success(data.reason, 'Success');
            this.exchangeAccountList.push({exchange: masterAccExchangeAccExchange, accountNumber: data?.exchangeAccountId,securityAccId: masterAccSecurityAccId})

            this.userService.exchangeAccTradinEnable(data?.exchangeAccountId, 1).subscribe({
              next: (data: any) => {
                if (data.status == 'SUCCESS') {
                  console.log(data, 'Succsesfully Trading enabled');
                }
              },
              error: (err: any) => {
                console.log(err.error.message, 'Error');
              },
            });


          } else {
            this.errorMessage = data.reason;
            this.toastr.error(
              this.errorMessage,
              'Unable to create exchange account'
            );

          }


          this.loadingAcc = false;
        },
        error: (err) => {
          this.errorMessage = err.error.message;
          this.toastr.error(
            this.errorMessage,
            'Unable to create exchange account'
          );
          this.loadingAcc = false;
        },
      });
  }
  getInstExchangeList(): void {
    const instCode = this.sessionStorageService.getItem('newInstCode');
    this.userService.getInstExchangesList(instCode, this.env).subscribe({
      next: (data: any) => {
        if (data.status == 'SUCCESS') {
          this.exchanges = data?.list;
          this.loading = false;
        }
      },
      error: (err: any) => {
        console.log(err.error.message, 'Error');
      },
    });
  }
  get formBankControl(): { [key: string]: AbstractControl } {
    return this.cashAccForm.controls;
  }


}

@Component({
    selector: 'subscription-pack-create-modal',
    templateUrl: 'subscription-pack-create-modal.html',
    styleUrls: ['./customer-creation.component.css'],
    standalone: false
})
export class SubscriptionPackCreationModalComponent {
  @ViewChild('tab123')
  tabs!: MdbTabsComponent;
  packageData: any;
  createCustomerSubmitted: boolean = false;
  exchangeVisible: boolean = false;
  exchangeTableVisible: boolean = false;
  isEditExchange = false;
  isEditPackage = false;
  subscriptionPlanForm: FormGroup = new FormGroup({});
  exchnageAddSubmitted = false;
  subscriptionPlanList: any;
  exchangeList: any = [];
  newExchangeList: any = [];
  loading: boolean = false;
  currencyList: any = [];
  exchanges: any = [];
  createSubscriptionPackSubmited: boolean = false;
  exchangeForm: FormGroup = new FormGroup({});
  env:any;
  constructor(
    public modalRef: MdbModalRef<SubscriptionPackCreationModalComponent>,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastr: ToastrService,
    private sessionStorageService: SessionService,
    public CustomerCreationComponent: CustomerCreationComponent,
    private tokenStorage: TokenStorageService
  ) {}

  ngOnInit(): void {
    this.getInstSubscriptionPackage();
    this.initializeSubscriptionPlanForm();
    this.initializeExchnageAddForm();
    this.getInstExchangeList();
    this.getCurrencyList();
    this.env = this.tokenStorage.getUserEnv();
  }

  getCurrencyList(){
    this.userService.getCurrencyList().subscribe(
      (data: any) => {
        this.currencyList = data?.list;
        ;



      },
      (err: any) => {
        this.toastr.error('Error Occured');

      }
    );
  }
  // get exchanges that related to subscription package
  getInstSubscriptionPackage(): void {
    const instCode = this.sessionStorageService.getItem('newInstCode');

    const packageId = this.sessionStorageService.getItem('packageId');
    if (packageId) {
      this.loading = true;


      this.userService.getInstSubscriptionPackageById(packageId).subscribe({
        next: (data: any) => {
          if (data.status == 'SUCCESS') {
            this.exchangeList = data?.packageList[0].exchangeList;

            //get whole exchange list related to specific institution
            this.userService.getInstExchangesList(instCode, this.env).subscribe({
              next: (data: any) => {
                if (data.status == 'SUCCESS') {
                  this.exchanges = data?.list;

                  this.loading = false;
                }
              },
              error: (err: any) => {
                console.log(err.error.message, 'Error');
              },
            });

            this.loading = false;
          } else {
            this.loading = false;
          }
        },
        error: (err) => {
          this.loading = false;
        },
      });
    }
  }
  getDefaultValuesOfExchange() {
    this.loading = true;
    this.userService
      .getDefaultValuesOfExchange(this.exchangeForm.value.exchangeType)
      .subscribe({
        next: (data: any) => {
          if (data.status == 'SUCCESS') {
            this.exchangeForm.patchValue({
              exchangeType: data?.exchange,
              exchangeCurrency: data?.currency,
              feedLevel:
                data?.levelOfFeed == 0
                  ? 'DELAYED'
                  : data?.levelOfFeed == 1
                    ? 'REAL TIME L1'
                    : 'REAL TIME L2',
            });
            this.loading = false;
          } else {
            this.loading = false;
          }
        },
        error: (err) => {
          this.loading = false;
        },
      });
  }

  getInstExchangeList(): void {
    const instCode = this.sessionStorageService.getItem('newInstCode');
    this.userService.getInstExchangesList(instCode, this.env).subscribe({
      next: (data: any) => {
        if (data.status == 'SUCCESS') {
          this.exchanges = data?.list;

          this.loading = false;
        }
      },
      error: (err: any) => {
        console.log(err.error.message, 'Error');
      },
    });
  }
  addExchange() {
    const instCode = this.sessionStorageService.getItem('newInstCode');
    this.exchnageAddSubmitted = true;
    this.loading = true;
    const packageId = this.sessionStorageService.getItem('packageId');
    if (this.exchangeForm.invalid) {
      this.loading = false;
      this.toastr.error('Please fill the form', 'Error');
      return;
    }
    const { exchangeType, exchangeCurrency, feedLevel } =
      this.exchangeForm.value;

    if (
      this.exchangeList.map((item: any) => item.exchange).includes(exchangeType)
    ) {
      this.loading = false;
      this.toastr.error('Exchange already added', 'Error');
      return;
    }

    if (packageId) {
      this.userService
        .updateSubscriptionPackage(packageId, instCode, 1, [
          {
            packageExchangeId: -1,
            exchange: exchangeType,
            currency: exchangeCurrency,
            feedLevel: feedLevel,
          },
        ])
        .subscribe({
          next: (data: any) => {
            if (data.status == 'SUCCESS') {
              this.getInstSubscriptionPackage();
              this.exchnageAddSubmitted = false;
              this.exchangeForm.reset();
              this.loading = false;
              this.toastr.success('Exchange added successfully', 'Success');
            } else {
              if (
                data.reason.includes("Requested feed level doesn't support")
              ) {
                this.getInstSubscriptionPackage();
                this.exchnageAddSubmitted = false;
                this.exchangeForm.reset();
                this.toastr.error(
                  "Requested feed level doesn't support, Default values are added",
                  'Error'
                );
                return;
              }

              this.loading = false;
              this.toastr.error(data.reason, 'Error');
            }
          },
        });
    } else {
      this.loading = false;
    }
  }

  saveExchange() {
    const instCode = this.sessionStorageService.getItem('newInstCode');
    this.exchnageAddSubmitted = true;
    this.loading = true;
    const packageId = this.sessionStorageService.getItem('packageId');
    if (this.exchangeForm.invalid) {
      this.loading = false;
      this.toastr.error('Please fill the form', 'Error');
      return;
    }
    const { exchangeId, exchangeType, exchangeCurrency, feedLevel } =
      this.exchangeForm.value;

    if (packageId) {
      this.userService
        .updateSubscriptionPackage(packageId, instCode, 1, [
          {
            packageExchangeId: exchangeId,
            exchange: exchangeType,
            currency: exchangeCurrency,
            feedLevel: feedLevel,
          },
        ])
        .subscribe({
          next: (data: any) => {
            if (data.status == 'SUCCESS') {
              this.getInstSubscriptionPackage();
              this.exchnageAddSubmitted = false;
              this.exchangeForm.reset();
              this.loading = false;
              this.isEditExchange = false;
              this.toastr.success('Exchange updated successfully', 'Success');
            } else {
              this.loading = false;
              this.toastr.error(data.reason, 'Error');
            }
          },
        });
    }
  }
  editExchange(id: any) {
    this.isEditExchange = true;

    this.exchangeList.filter((item: any) => {
      if (item.packageExchangeId == id) {
        this.exchangeForm.patchValue({
          exchangeId: item.packageExchangeId,
          exchangeType: item.exchange,
          exchangeCurrency: item.currency,
          feedLevel: item.feedLevel,
        });
      }
    });

  }
  createSubscriptionPlan() {
    const instCode = this.sessionStorageService.getItem('newInstCode');
    if (this.isEditPackage || this.exchangeVisible) {


      this.loading = true;
      const { packageName, packageDescription } =
        this.subscriptionPlanForm.value;
      this.userService
        .updateSubscriptionPackageDetails(
          this.sessionStorageService.getItem('packageId'),
          instCode,
          1,
          packageName,
          packageDescription
        )
        .subscribe({
          next: (data: any) => {
            if (data.status == 'SUCCESS') {
              this.loading = false;
              this.CustomerCreationComponent.getInstSubscriptionPackageList();
              this.toastr.success(
                'Subscription package updated  successfully',
                'Success'
              );
            } else {
              this.loading = false;
              this.toastr.error(data.reason, 'Error');
            }
          },
        });
    } else {
      this.sessionStorageService.removeItem('packageId');
      this.exchangeList = [];
      this.createSubscriptionPackSubmited = true;

      if (this.subscriptionPlanForm.invalid) {
        this.toastr.error('Please fill the form', 'Error');
        return;
      }
      this.loading = true;
      const { packageName, packageDescription } =
        this.subscriptionPlanForm.value;
      this.userService
        .addSubscriptionPackage(
          packageName,
          packageDescription,
          instCode,
          1,
          'NO'
        )
        .subscribe({
          next: (data: any) => {
            if (data.status == 'SUCCESS') {
              this.exchangeVisible = true;

              this.sessionStorageService.setItem(
                'packageId',
                data.packageList[0].packageId
              );
              this.CustomerCreationComponent.getInstSubscriptionPackageList();

              this.loading = false;
              this.toastr.success(
                'Subscription package added  successfully',
                'Success'
              );
              setTimeout(() => {
                this.tabs.setActiveTab(1);
              }, 100);
            } else {
              this.loading = false;
              this.toastr.error(
                data.reason,
                'Subscription package added failed'
              );
            }
          },
          error: (err) => {
            this.loading = false;
            this.toastr.error(
              err.error.message,
              'Subscription package added failed'
            );
          },
        });
    }
  }

  initializeSubscriptionPlanForm(): void {
    this.subscriptionPlanForm = this.formBuilder.group({
      packageName: [this.packageData?.packageName, [Validators.required]],
      packageDescription: [
        this.packageData?.packageDescription,
        [Validators.required],
      ],
      defaultSubscriptionPlan: [
        this.packageData?.isDefault == 'YES' ? true : false,
      ],
      packageId: [this.packageData?.packageId],
    });
  }
  initializeExchnageAddForm(): void {
    this.exchangeForm = this.formBuilder.group({
      exchangeType: ['', [Validators.required]],
      exchangeId: [''],
      exchangeCurrency: ['', [Validators.required]],
      feedLevel: ['', [Validators.required]],
    });
  }
  exchangeRemove(id: any) {
    this.exchangeList = this.exchangeList.filter((item: any) => {
      item.id !== id;
    });
  }
  get formExchangeControl(): { [key: string]: AbstractControl } {
    return this.exchangeForm.controls;
  }

  get formSubscriptionPlanControl(): { [key: string]: AbstractControl } {
    return this.subscriptionPlanForm.controls;
  }
  closeModal(): void {
    this.modalRef.close();
  }

}
